import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import CityGrid from '../components/CityGrid';
import SignupForm from '../components/SignupForm';

const Landing = () => {
  const [selectedCity, setSelectedCity] = useState('');
  const navigate = useNavigate();

  const handleCitySelect = useCallback((city) => {
    console.log('City selected:', city); // Debug log
    setSelectedCity(city);
    
    // Improved scroll for mobile devices
    setTimeout(() => {
      const signupSection = document.getElementById('signup-section');
      if (signupSection) {
        // Use different scroll method for better mobile compatibility
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        
        if (isMobile) {
          // For mobile, use scrollIntoView with different options
          signupSection.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
        } else {
          signupSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        
        // Also try focus for better mobile experience
        const firstInput = signupSection.querySelector('input');
        if (firstInput && !isMobile) {
          setTimeout(() => firstInput.focus(), 500);
        }
      }
    }, 200);
  }, []);

  const handleSignupSuccess = useCallback(() => {
    navigate('/success');
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="px-6 md:px-12 lg:px-24 py-12 md:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <p className="caption-text text-muted-foreground mb-4">2026 BOOK TOUR</p>
              <h1 className="hero-title text-6xl md:text-8xl mb-6">
                COLTURE<br />
                PLAYBOOK<br />
                TOUR
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-8">
                Sign up now to secure your spot to purchase limited tickets for the city of your choosing once tour dates are announced.
              </p>
              <a 
                href="#signup-section" 
                className="btn-primary inline-block"
                data-testid="hero-signup-btn"
              >
                SIGN UP NOW
              </a>
            </div>
            <div className="relative h-96 md:h-full min-h-[400px]">
              <img
                src="https://customer-assets.emergentagent.com/job_playbook-tour-dates/artifacts/cr6dnwa2_ColturePlaybookv2_draft7.jpg"
                alt="The Colture Playbook Vol 2"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Cities Section */}
      <section className="px-6 md:px-12 lg:px-24 py-12 md:py-24 bg-secondary">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <p className="caption-text text-muted-foreground mb-4\">TOUR CITIES</p>
            <h2 className="section-title text-4xl md:text-5xl mb-4">SELECT YOUR CITY</h2>
            <p className="text-lg text-muted-foreground max-w-2xl">
              We're visiting six major cities across North America. 
              Select your city below to register for priority ticket access when dates are announced.
            </p>
          </div>
          <CityGrid onCitySelect={handleCitySelect} selectedCity={selectedCity} />
        </div>
      </section>

      {/* Signup Section */}
      <section id="signup-section" className="px-6 md:px-12 lg:px-24 py-12 md:py-24">
        <div className="max-w-2xl mx-auto">
          <div className="mb-12 text-center">
            <p className="caption-text text-muted-foreground mb-4">RESERVE YOUR SPOT</p>
            <h2 className="section-title text-4xl md:text-5xl mb-4">SIGN UP</h2>
            <p className="text-lg text-muted-foreground">
              Register below to secure priority access to purchase limited tickets when tour dates are announced.
            </p>
          </div>
          <SignupForm 
            preselectedCity={selectedCity} 
            onSuccess={handleSignupSuccess}
          />
        </div>
      </section>

      {/* Footer */}
      <footer className="px-6 md:px-12 lg:px-24 py-12 bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto text-center">
          <p className="caption-text mb-4">COLTURE PLAYBOOK TOUR 2026</p>
          <p className="text-sm text-muted-foreground">
            © 2026 Colture Playbook. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Landing;